/*
 *  Copyright (c) 2018-present, Evgeny Nadymov
 *
 * This source code is licensed under the GPL v.3.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';

function ChatLink(props) {
    return <div />;
}

ChatLink.propTypes = {
    title: PropTypes.string.isRequired,
    photo: PropTypes.object,
    username: PropTypes.string.isRequired
};

export default ChatLink;
